export default "__VITE_PUBLIC_ASSET__b60d0716__"